import styled from "styled-components";

export const StyledSection = styled.section`
  padding: 20px 16px;
`;

export const ProfileCont = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const Styledbtn = styled.button`
  width: 18px;
`;

export const Styledimg = styled.img`
  width: 100%;
`;
